import React from 'react'
import { Link } from 'react-router-dom'

export default function SignupChoice() {
  return (
    <div className="auth-shell warm-theme">
      <div className="auth-card" style={{ width: 'min(420px, 100%)' }}>
        <h1>Let's get you to the right place</h1>
        <p className="muted" style={{ fontSize: 13.5 }}>Tell us a bit about why you're here.</p>

        <Link to="/find-care" className="card" style={{ display: 'block', marginTop: 16, textDecoration: 'none' }}>
          <h3 style={{ margin: '0 0 4px' }}>I'm looking for care</h3>
          <p className="muted" style={{ margin: 0, fontSize: 13.5 }}>Complete a structured intake and get routed to a provider who fits.</p>
        </Link>

        <Link to="/signup/practice" className="card" style={{ display: 'block', marginTop: 12, textDecoration: 'none' }}>
          <h3 style={{ margin: '0 0 4px' }}>Group Practices & Clinics</h3>
          <p className="muted" style={{ margin: 0, fontSize: 13.5 }}>Set up a practice with a team of providers.</p>
        </Link>

        <Link to="/signup/provider" className="card" style={{ display: 'block', marginTop: 12, textDecoration: 'none' }}>
          <h3 style={{ margin: '0 0 4px' }}>I'm an individual provider</h3>
          <p className="muted" style={{ margin: 0, fontSize: 13.5 }}>Sign up on your own — no practice or invite required.</p>
        </Link>

        <p className="muted" style={{ fontSize: 13, marginTop: 16 }}>
          Already have an account? <Link to="/login">Sign in</Link>
        </p>
      </div>
    </div>
  )
}
